import React, { useEffect, useState } from "react";
import "./InspectionStyles.css";
import DashboardGrid from "./DashboardGrid";
import GenericPopup from "../../../Components/GenericPopup";
import BrokerCarrierForm from "./BrokerCarrierForm";
import { NetworkManager } from "../../../Components/NetworkManager";
import { CommonUtil } from "../../../utils/CommonUtil";
import ToastManager from "../../../Components/ToastManager";
import DashboardWidget from "./DashboardWidget";
import { Events } from "../../Languages/Events";

const InspectionDashboard = () => {
  const saasOrgId = CommonUtil.getSaasOrgId();
  const [selectedWidget, setSelectedWidget] = useState<any>(null);
  const [popupInfo, setPopupInfo] = useState<any>(null);
  const [count, setCount] = useState<any>(null);

  useEffect(() => {
    getDashboardCount();
    document.addEventListener(Events.SWITCH_CUSTOMER_EVENT, onSwitchCustomer);
    return () => {
        document.removeEventListener(Events.SWITCH_CUSTOMER_EVENT, onSwitchCustomer);
    }
  }, []);

  let onSwitchCustomer = () => {
      Events.dispatchBreadCrumbEvent();
  }

  const formComponentMap: any = {
    "Broker/Carriers": BrokerCarrierForm,
  };

  let onLoginError = (err: any) => {
    console.log(err);
  }

  const getDashboardCount = () => {
      var url = `api/dashboard/count?saasOrgId=${saasOrgId}`;
      NetworkManager.sendJsonRequest(url, "", "", "GET", true, onDashboardCount, onLoginError);
  }
  
  const onDashboardCount = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (restData && !restData.errorMessage) {
        setCount(restData);
      }else{
        ToastManager.showToast(restData.errorMessage, "Error");
      }
    }
  }

  const FormComponent = popupInfo ? formComponentMap[popupInfo.widget] : null;

  const handleWidgetSelect = (widget: any) => {
    setSelectedWidget(widget);
  };

  const handleAddClick = (widgetLabel: string) => {
    setPopupInfo({ widget: widgetLabel });
  };

  const closePopup = () => {
    setPopupInfo(null);
  };
  
  return (
    <div className="inspection-features">
      <div className="container-fluid py-3 px-3">
        <DashboardWidget onAddClick={handleAddClick} 
          count={count} widgetSelected={handleWidgetSelect}/>
      </div>
      <div className="container-fluid px-3">
        <DashboardGrid selectedWidget={selectedWidget} count={count} getDashboardCount={getDashboardCount}/>
      </div>
      {popupInfo && (
        <GenericPopup
          header={popupInfo.widget}
          mode="add"
          onClose={closePopup}
          size="lg"
        >
          {FormComponent && <FormComponent mode={popupInfo.mode} onClose={closePopup} getDashboardCount={getDashboardCount} />}
        </GenericPopup>
      )}
    </div>
  );
};

export default InspectionDashboard;
